var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTogglerIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 14,
    viewBox: "0 0 18 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 14L-8.74219e-08 12L18 12L18 14L0 14ZM-2.62268e-07 8L-3.4969e-07 6L18 6L18 8L-2.62268e-07 8ZM-6.11959e-07 0L-5.24537e-07 2L18 2L18 -7.86805e-07L-6.11959e-07 0Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTogglerIcon);
export default __webpack_public_path__ + "static/media/toggler-icon.3508bad2cec9bd77637aec2e3fd01cc9.svg";
export { ForwardRef as ReactComponent };